import { mergeHeaders } from './requestConfig';
import { type ApiConfig } from '../types/api';
import packageJson from '../../package.json' with { type: 'json' };

export function getConfigWithMetadata(apiConfig: ApiConfig, functionName: string) {
  return {
    ...apiConfig,
    headers: mergeHeaders(apiConfig.headers, {
      'x-search-api-function': functionName,
      'x-search-api-version': packageJson.version,
    }),
  };
}

export function hasAuthorization(config: ApiConfig) {
  return Boolean(config.jwtToken) || Boolean(config.headers?.['Authorization']) || Boolean(config.getToken);
}
